<template>
<div class="col-md-12 col-sm-12 col-xs-12 info-form-content p-l-r-0">
    <!-- <a href="#" class="preview " id="solepreview-btn" v-on:click="ifpreviewopen1()">
        <img src="../assets/privew-icon.png">
    </a>
    <a href="#" class="preview preview_btn-width" id="solepreview-close-btn" v-on:click="ifpreviewclose1()" style="display: none;">
        <img src="../assets/close-icon.png">
    </a> -->
    <div class="sole_form_block" id="sole_form_block" v-if="form_status">
        <div class="accordion" id="accordion" role="tablist">
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-1 variant="info">Sole Proprietorship - Entity Info <span class="accordion_arrow"><img src="../assets/icon-19.png"></span></b-button>
                </b-card-header>
                <b-collapse id="accordion-1" visible accordion="sole-accordion" role="tabpanel">
                    <b-card-body>
                        <form>
                            <!-- <div class="col-md-12 p-l-r-0 f-left text-right edit_icon">
                                <a href="#"><img src="../assets/edit_icon.png"></a>
                            </div> -->
                            <div class="col-md-12 p-l-r-0 f-left less_space_bottom">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="name">Name (in full)*</label>
                                    <input type="text" class="form-control" id="name" v-model="owner_information.name">
                                    <span class="text-danger" v-if="validation_errors.name">Please enter name</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="mobile_no">Mobile Number*</label>
                                    <input type="text" class="form-control" id="mobile_no" v-model="owner_information.mobile_no">
                                    <span class="teptext">(Linked with Aadhar)</span>
                                    <span class="text-danger" v-if="validation_errors.mobile_no">{{validation_errors.mobile_no}}</span>

                                </div>
                            </div>

                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="email_id">Email ID*</label>
                                    <input type="text" class="form-control" id="email_id" v-model="owner_information.email_id">
                                     <span class="text-danger" v-if="validation_errors.email_id">{{validation_errors.email_id}}</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="'Birth'">Date of Birth*</label>
                                    <!-- <input type="text" class="form-control" id="Birth" v-model="owner_information.dob"> -->
                                    <Datepicker class="form-control" v-model="owner_information.dob"></Datepicker>
                                    <span class="text-danger" v-if="validation_errors.dob">Please select date of birth</span>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="panNumber">PAN Number*</label>
                                    <input type="text" class="form-control" id="panNumber" v-model="owner_information.pan_number">
                                     <span class="text-danger" v-if="validation_errors.pan_number">Please enter pan number</span>
                                </div>
                                <div class="form-group col-md-6 p-r-0 f-left">
                                    <label for="address">Address*</label>
                                    <textarea class="form-control form_textarea" rows="4" id="address" v-model="owner_information.address"></textarea>
                                    <span class="text-danger" v-if="validation_errors.address">Please enter address</span>
                                </div>
                            </div>





                            <!-- <proof_upload :parentName="'sole'"/> -->
                            <div class="col-md-12 p-l-r-0 f-left proof_upload">
                                <div class="col-md-12 p-l-r-0 f-left">
                                    <div class="form-group col-md-6 p-r-0 f-left choosefile-upload">
                                        <pan_upload v-bind:propdata="props_from_parent" v-bind:from_key="1" @UpdateFilePath="UpdateFilePath" />
                                        <span id="file-chosen" v-if="owner_information.pan_url">
                                            <a :href="owner_information.pan_url" target="_blank">View</a>
                                        </span>
                                         <span class="text-danger" v-if="validation_errors.pan_url">Please update self-attested PAN document</span>
                                    </div>
                                    <div class="form-group col-md-6 p-l-r-0 f-left choosefile-upload">
                                        <aadhar_upload v-bind:propdata="props_from_parent" v-bind:from_key="1" @UpdateFilePath="UpdateFilePath" />
                                        <span id="file-chosen" v-if="owner_information.aadhar_url">
                                            <a :href="owner_information.aadhar_url" target="_blank">View</a>
                                        </span>
                                          <span class="text-danger" v-if="validation_errors.aadhar_url">Please update self-attested Aadhar document</span>
                                    </div>
                                    <div class="form-group col-md-6 p-r-0 f-left choosefile-upload">
                                        <photo_upload v-bind:propdata="props_from_parent" v-bind:from_key="1" @UpdateFilePath="UpdateFilePath" />
                                        <span id="file-chosen" v-if="owner_information.passport_size_photo">
                                            <a :href="owner_information.passport_size_photo" target="_blank">View</a>
                                        </span>
                                        <span class="text-danger" v-if="validation_errors.passport_size_photo">Please update passport size photo</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left border-seperator"></div>

                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6 p-l-r-0 f-left">
                                    <label for="Website">Website (if available)*</label>
                                    <input type="text" class="form-control" id="Website" v-model="owner_information.website">
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-12 p-l-r-0 nospace f-left">
                                    <label for="Website">Brief note on the object of business*</label>
                                    <textarea id="Website" rows="4" class="form-control text-area" v-model="owner_information.brief_note"></textarea>
                                    <span class="text-danger" v-if="validation_errors.brief_note">Please enter Brief note  of business</span>
                                </div>
                            </div>

                            <bills_agreement v-bind:propdata="props_from_parent" :owner_information="owner_information" @UpdateFilePath="UpdateFilePath" :other_validation="validation_errors" />

                            <div class="col-md-12 p-l-r-0 f-left ">
                                <br>
                                <button type="button" class="btn btn-primary gobtn submit" @click="Submit()">Submit</button>
                            </div>
                        </form>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
    </div>
    <div v-else class="sole_form_priview_block priview_block" id="sole_form_priview_block" >
        <sole_form_preview :prop_owners="owner_information" />
    </div>
</div>
</template>

<script>
import company_info from "../services/company_info"
import bills_agreement from './bills_agreement';
import sole_form_preview from './sole_form_preview';
import aadhar_upload from './aadhar_upload';
import photo_upload from './photo_upload';
import pan_upload from './pan_upload';
import Datepicker from 'vuejs-datepicker';
export default {
    name: 'sole_proprietorship_accordion',
    props: ['subscription_params'],
    watch: {
        subscription_params: {
            handler: function () {
                this.UpdateChildPropData();
            },
            immediate: true
        },
    },
    components: {
        bills_agreement,
        sole_form_preview,
        aadhar_upload,
        pan_upload,
        photo_upload,
        Datepicker
    },
    data() {
        return {
            form_status:true,
            props_from_parent: {
                subscribtion_id: '',
                folder_id: '',
                type: ''
            },
            validation_errors:{

            },
            owner_information: {
                name: '',
                mobile_no: '',
                email_id: '',
                dob: '',
                pan_url: '',
                pan_number:'',
                address:'',
                aadhar_url: '',
                passport_size_photo: '',
                website: '',
                brief_note: '',
                registered_office: '',
                registered_office_doc_url: '',
                any_utility_bill_url: '',
                noc: '',
                authorization_letter_url: ''
            }
        }
    },
    methods: {
        UpdateFilePath(payload) {
            if (payload.src == 'aadhar_url') {
                this.owner_information.aadhar_url = payload.url;
            }
            if (payload.src == 'pan_url') {
                this.owner_information.pan_url = payload.url;
            }
            if (payload.src == 'passport_size_photo') {
                this.owner_information.passport_size_photo = payload.url;
            }
            if (payload.src == 'noc') {
                this.owner_information.noc = payload.url;
            }
            if (payload.src == 'registered_office_doc_url') {
                this.owner_information.registered_office_doc_url = payload.url;
            }
            if (payload.src == 'any_utility_bill_url') {
                this.owner_information.any_utility_bill_url = payload.url;
            }
            if (payload.src == 'authorization_letter_url') {
                this.owner_information.authorization_letter_url = payload.url;
            }
            if (payload.src == 'registered_office') {
                this.owner_information.registered_office = payload.url;
            }
        },
        UpdateChildPropData() {
            this.props_from_parent = this.subscription_params
            this.props_from_parent.date = new Date()
            var db_params = this.subscription_params.company_info;
            if (db_params) {
                 this.form_status=db_params.status=='pending' ? true :false;
                if (this.subscription_params.company_info) {
                    this.owner_information = JSON.parse(this.subscription_params.company_info.onwer_information);
                    // this.owner_information = JSON.parse(this.subscription_params.company_info.owner_information)
                }
            }
        },
        Submit() {
            this.validation_errors={}
            company_info.post({
                    onwer_information: this.owner_information,
                    onwer_information_all: this.owner_information,
                    subscription_id: this.subscription_params.subscribtion_id,
                    entity: 'sole'
                })
                .then(response => {
                    if (response.data.status == 'success') {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'success',
                            text: 'Details saved successfully',
                            ignoreDuplicates: true
                        });
                    }
                    this.$emit("saveSuccessToparent", {
                            src: 'sole'
                        });
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'warn',
                            text: 'Please fill all required fields',
                            ignoreDuplicates: true
                        });
                        var err=error.response.data.status;
                            var temp={};
                        Object.keys(err).forEach((key) => {
                            var err_text=err[key][0].split(".");
                            temp[key.split(".")[1]]=err_text[1]
                        });
                        this.validation_errors=temp
                    }
                })
        },
        ifpreviewopen1() {
            document.getElementById('sole_form_priview_block').style.display = 'block';
            document.getElementById('sole_form_block').style.display = 'none';
            document.getElementById('solepreview-btn').style.display = 'none';
            document.getElementById('solepreview-close-btn').style.display = 'block';
        },
        ifpreviewclose1() {
            document.getElementById('sole_form_priview_block').style.display = 'none';
            document.getElementById('sole_form_block').style.display = 'block';
            document.getElementById('solepreview-btn').style.display = 'block';
            document.getElementById('solepreview-close-btn').style.display = 'none';
        }
    },
};
</script>
